export var KYCReviewTaskStatus;
(function (KYCReviewTaskStatus) {
    KYCReviewTaskStatus["OPEN"] = "OPEN";
    KYCReviewTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    KYCReviewTaskStatus["RESOLVED"] = "RESOLVED";
    KYCReviewTaskStatus["REJECTED"] = "REJECTED";
})(KYCReviewTaskStatus || (KYCReviewTaskStatus = {}));
export const KYC_REVIEW_TASK_STATUSES = Object.values(KYCReviewTaskStatus);
export var KYCReviewReasonCode;
(function (KYCReviewReasonCode) {
    KYCReviewReasonCode["OCR_MRZ_FAILURE"] = "OCR_MRZ_FAILURE";
    KYCReviewReasonCode["MISSING_REQUIRED_FIELD"] = "MISSING_REQUIRED_FIELD";
    KYCReviewReasonCode["LOW_CONFIDENCE"] = "LOW_CONFIDENCE";
    KYCReviewReasonCode["POSTIDENT_MISMATCH"] = "POSTIDENT_MISMATCH";
})(KYCReviewReasonCode || (KYCReviewReasonCode = {}));
//# sourceMappingURL=kyc-manual-review.types.js.map